<template>
  <v-container fill-height fluid>
    <v-layout justify-center align-center>
      <v-flex column lg8 align-self-center>
        <material-card
          icon="mdi-account-group"
          color="indigo"
          :title="$t('Pages.Users.add_new')"
          :text="$t('Common.enter_details')">
          <v-card-text>

            <user-form @save="add" :user="user"></user-form>
          </v-card-text>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
    import Form from '../../services/Form'
    import UserForm from './Form'
    import _ from 'lodash';
export default {
  components: {UserForm},
  data: () => ({
    user: {profile:{}},
  }),
  computed: {
  },
  created () {
  },
  methods: {
      add(data){
          this.repositories.user.store(Form.prepare(data)).then((response) => {
              this.$toast.success(response.data.message);
              this.user = {profile:{}};
          });
      }
  }
}
</script>

<style lang="scss">

</style>
